import { useLocation } from "react-router-dom";
import logo from "../../assets/logo.svg";
import Steps from "../Steps";

import { Container, Title, Text } from "./style";

const NavBar = () => {
  const { pathname } = useLocation();

  const finalSteps =
    pathname.includes("/descriptive_questions") ||
    pathname.includes("/submit_form");

  return (
    <Container>
      <img src={logo} alt="Kenzie Academy" />
      {pathname === "/" && (
        <>
          <Title>
            Bem-vindo(a) ao processo seletivo para estudar na <b>Kenzie</b>
          </Title>

          <Steps />

          <Text>
            Estamos muito felizes com o seu interesse em começar uma carreira
            como
            <b> desenvolvedor(a) full stack</b>
          </Text>

          <Text>
            Lembrando que não existe resposta certa ou errada, mas tente se
            expressar bem, para que o time de admissões possa te conhecer
            melhor.
          </Text>
        </>
      )}

      {pathname === "/influ" && (
        <>
          <Title>
            Bem-vindo(a) ao processo seletivo para estudar na <b>Kenzie</b>
          </Title>

          <Steps />

          <Text>
            Estamos muito felizes com o seu interesse em começar uma carreira
            como
            <b> desenvolvedor(a) full stack</b>
          </Text>

          <Text>
            Lembrando que não existe resposta certa ou errada, mas tente se
            expressar bem, para que o time de admissões possa te conhecer
            melhor.
          </Text>
        </>
      )}

      {pathname === "/v2" && (
        <>
          <Title style={{ marginBottom: "0.5rem" }}>
            Te desejamos boas vindas ao processo seletivo da{" "}
            <b>Kenzie Academy</b>
          </Title>

          <Text>
            Estamos muito felizes com o seu interesse em começar uma carreira
            como pessoa <b>programadora full stack web.</b>
          </Text>

          <Text>
            Lembramos que não existe resposta certa ou errada para o formulário
            ao lado, apenas tente se expressar da melhor forma que conseguir
            para que o time de admissões possa te conhecer melhor.
          </Text>
        </>
      )}

      {pathname.includes("/personal_data") && (
        <>
          <Title>Dados Pessoais</Title>

          <Steps />

          <Text>
            Chegou a hora de você preencher nosso formulário para te conhecermos
            melhor!
          </Text>
        </>
      )}

      {pathname.includes("/experience") && (
        <>
          <Title>Sobre sua experiência e dia-a-dia</Title>

          <Steps />

          <Text>
            Neste formulário, queremos saber mais sobre sua experiência, como é
            o seu dia-a-dia e como está seu momento atual.
          </Text>
        </>
      )}

      {finalSteps && (
        <>
          <Title>Perguntas descritivas</Title>

          <Steps />

          <Text>
            É legal você dar atenção nas respostas aqui, hein? Assim você tem
            mais chances de garantir sua aprovação para a próxima fase
          </Text>

          <Text>
            Importante: Lembre-se que o formulário é a primeira etapa do nosso
            processo seletivo e tem caráter eliminatório.
          </Text>
        </>
      )}
    </Container>
  );
};

export default NavBar;
